import React from "react";
import worksCardEffect from "../../common/worksCardEffect";
import "../../css/Selection2.scss";

const Selection2 = () => {
  React.useEffect(() => {
    worksCardEffect();
  }, []);

  return (
    <section
      className="portfolio full-bg"
      style={{
        height: "87vh",
      }}
    >
      
      <div className="container-fluid">
        <div
          className="row"
          style={{ display: "flex", flexWrap: "wrap", width: "100%" }}
        >
        
          <div
            className="col-lg-3 col-md-6 cluom current"
            data-tab="tab-1"
            style={{ width: "33.33%", cursor:"pointer" }}
            onClick={() => window.location.href = "/interior-design/residential"}

          >
             
            <div className="info">
              <h6 className="custom-font">
                <br />
              </h6>
              <h6
                style={{
                  fontSize: "18px",
                }}
              >
                Residential Projects
              </h6>
            </div>
            <div className="more">
              {/* <a
                href="/interior-design/residential"
                style={{
                  color: "white",
                }}
              >
                VIEW RESIDENTIAL PROJECTS{" "}
                <i className="fas fa-chevron-right"></i>
              </a> */}
            </div>
         
          </div>
         
          <div
            className="col-lg-3 col-md-6 cluom"
            data-tab="tab-2"
            style={{ width: "33.33%", cursor:"pointer" }}
            onClick={() => window.location.href = "/interior-design/commercial"}
          >
            <div className="info">
              <h6 className="custom-font">
                <br />
              </h6>
              <h6
                style={{
                  fontSize: "18px",
                }}
              >
                Commercial Projects
              </h6>
            </div>
            <div className="more">
              {/* <a
                href="/interior-design/commercial"
                style={{
                  color: "white",
                }}
              >
                VIEW COMMERCIAL PROJECTS<i className="fas fa-chevron-right"></i>
              </a> */}
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 cluom"
            data-tab="tab-3"
            style={{ width: "33.33%", cursor:"pointer" }}
            onClick={() => window.location.href = "/exterior-design"}
          >
            <div className="info">
              <h6 className="custom-font">
                <br />
              </h6>
              <h6
                style={{
                  fontSize: "18px",
                }}
              >
                Exterior Designs
              </h6>
            </div>
            <div className="more">
              {/* <a
                href="/project-details"
                style={{
                  color: "white",
                }}
              >
                VIEW EXTERIOR PROJECTS <i className="fas fa-chevron-right"></i>
              </a> */}
            </div>
          </div>
        </div>
      </div>
      <div className="glry-img">
        <div
          id="tab-1"
          className="bg-img tab-img current"
          style={{
            backgroundImage: `url(../Images/landingpageimage/image5.jpg)`,
          }}
          data-overlay-dark="2"
        ></div>
        <div
          id="tab-2"
          className="bg-img tab-img"
          style={{
            backgroundImage: `url(../Images/landingpageimage/image8.jpg)`,
          }}
          data-overlay-dark="2"
        ></div>
        <div
          id="tab-3"
          className="bg-img tab-img"
          style={{
            backgroundImage: `url(../Images/landingpageimage/image9.png)`,
          }}
          data-overlay-dark="2"
        ></div>
      </div>
    </section>
  );
};

export default Selection2;
